import jsCookie, { CookieAttributes } from 'js-cookie';
import { parse } from 'query-string';

import { InMemoryCookies, InMemoryCookiesType } from './cookies';

export const SESSION_TOKEN_KEY = '__acadly__session__token__';
export const COURSE_KEY = '__acadly__course__';

const COOKIE_SETTINGS: CookieAttributes = {
  expires: 1,
  secure: process.env.REACT_APP_PROTOCOL === 'https',
  sameSite: process.env.REACT_APP_PROTOCOL === 'https' ? 'none' : 'lax',
};

let cookie: InMemoryCookiesType = jsCookie;

cookie.set('test', 'test');

if (cookie.get('test') !== 'test') {
  // cookies are not enabled, fallback to in-memory-cookies
  cookie = InMemoryCookies;
  console.warn('cookies are disabled!');
}

export function refreshContextCourseId(courseId: string) {
  cookie.remove(COURSE_KEY);
  setContextCourseId(courseId);
}

export function setContextCourseId(courseId?: string) {
  if (!courseId) return;
  cookie.set(COURSE_KEY, courseId, COOKIE_SETTINGS);
}

export function getContextCourseId() {
  return cookie.get(COURSE_KEY);
}

export function refreshSessionToken(token: string) {
  cookie.remove(SESSION_TOKEN_KEY);
  setSessionToken(token);
}

export function setSessionToken(token: string) {
  cookie.set(SESSION_TOKEN_KEY, token, COOKIE_SETTINGS);
}

export function getSessionToken() {
  return cookie.get(SESSION_TOKEN_KEY);
}

export function removeSessionToken() {
  cookie.remove(SESSION_TOKEN_KEY);
  cookie.remove(COURSE_KEY);
}

export function getApplicationLaunchData() {
  const { access_token: applicationToken, launch_error: launchError } = parse(window.location.search);
  return {
    token: applicationToken instanceof Array ? applicationToken[0] : applicationToken,
    launchError: launchError instanceof Array ? launchError[0] : launchError,
  };
}
